export interface ServiceProvider {
  _id: string;
  name: string;
}

export interface Carrier {
  _id: string;
  name: string;
  code: string;
  serviceProviders: ServiceProvider[];
}

export interface CarrierResponse {
  msg: string;
  data: Carrier[];
}

interface PurchaseInvoiceItem {
  carrierId: string;
  purchaseInvoiceNumber: string;
  _id: string;
}

/**
 * Finds the purchase invoice number for a given carrier ID.
 * @param carrierId - The carrier ID to match.
 * @param purchaseInvoiceNumbers - Array of purchase invoice objects.
 * @returns The matched purchaseInvoiceNumber string, or null if not found.
 */
export function getPurchaseInvoiceNumberByCarrierId(
  carrierId: string,
  purchaseInvoiceNumbers: PurchaseInvoiceItem[],
): string | null {
  const match = purchaseInvoiceNumbers.find(item => item.carrierId === carrierId);
  return match ? match.purchaseInvoiceNumber : '-';
}

export type carrierProvider = {
  _id: string;
  name: string;
};

export type CarrierListArray = {
  _id: string;
  name: string;
  code: string;
  serviceProviders: carrierProvider[];
};

export function getCarrierNameById(carrierList: CarrierListArray[], carrierId: string): string | null {
  const carrier = carrierList.find(c => c._id === carrierId);
  return carrier ? carrier.name : null;
}
